import React from 'react'
import SupplyBillAgreeIco from '../../../supplyBill/view/items/SupplyBillAgreeIco'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import IcoButtonStatus from '../../../../UI/form/icoButtons/IcoButtonStatus';
import { statusPaymentText } from '../../../../../helpers/status/StatusSupplyOrderHelper';

const SupplyBillPaymentShort = ({ payments }) => {
  return (
    <div>
        {
            payments && payments.length > 0 ?
                payments.map(payment => {
                    return (
                        // <Status
                        // 	status={supplyBill.payments[0].status}
                        // 	text={statusSupplyBillPaymentText[supplyBill.payments[0].type]}
                        // />

                        // <SupplyBillAgreeIco
                        //     // onClick={e => setOpen(true)}
                        //     key={payment.id}
                        //     text={'Cтатус оплати'}
                        //     textOk={'Сплачено'}
                        //     ico={<CheckCircleIcon />}
                        //     value={
                        //         payment.status && payment.status === 'pay' ? true : payment.status
                        //     }
                        // />
                        <div key={payment.id}>
                            <IcoButtonStatus
                                // classNameMain={}
                                ico={<CheckCircleIcon />}
                                text={'Cтатус оплати'}
                                textStatus={statusPaymentText[payment.status]}
                                status={payment.status}
                                // onClick={e => setOpen(true)}
                            />
                            <p>
                                {payment.billNumber}
                            </p>
                        </div>
                    )
                })
            : ''
        }
    </div>
  )
}

export default SupplyBillPaymentShort